import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';

import { ButtonMode, ButtonSize, ButtonTheme, IconButtonTheme, IconPosition } from '@fcom/ui-components';
import { FragmentService, LoaderType, MediaQueryService } from '@fcom/common';
import { CmsArticle } from '@fcom/core-api/interfaces';
import { Category } from '@fcom/dapi/api/models';
import { BoundWithServices, FinnairServiceItemWithUpsell } from '@fcom/dapi/interfaces';

@Component({
  selector: 'fin-upsell-card',
  templateUrl: 'upsell-card.component.html',
  styleUrls: ['../../../../assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpsellCardComponent implements OnInit {
  readonly ButtonMode = ButtonMode;
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconButtonTheme = IconButtonTheme;
  readonly Category = Category;
  readonly IconPosition = IconPosition;
  readonly LoaderType = LoaderType;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  isMobile$: Observable<boolean>;

  @Input()
  service: FinnairServiceItemWithUpsell;

  @Input() boundWithServices: BoundWithServices;

  @Output()
  upsellClicked: EventEmitter<Category> = new EventEmitter<Category>();

  article$: Observable<CmsArticle>;

  constructor(
    private fragmentService: FragmentService,
    private mediaQueryService: MediaQueryService
  ) {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
  }

  ngOnInit(): void {
    this.article$ = this.fragmentService.getFragment(this.service.upsell.articleKey);
  }
}
